export default "__VITE_ASSET__51430e39__"